<template>
  <div class="rich-box"
    :class="{ 'aie-content': mode == 'aiEditor', 'aie-theme-light': mode == 'aiEditor', 'ql-snow': mode != 'aiEditor' }"
    :style="{ 'height': height }">
    <div ref="rich" :class="{ 'ql-editor': mode != 'aiEditor' }" style="height: 100%;overflow:auto" v-html="showVal"
      @click="clickHandler"></div>
    <el-image-viewer v-if="showViewer" :zIndex="9999" :onClose="closeViewer" :onSwitch="switchHand" :url-list="srcList"
      :initial-index="curtIndex"></el-image-viewer>
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import "quill/dist/quill.snow.css";
export default {
  name: 'l-rich',
  components: {
    ElImageViewer
  },
  props: {
    isUploadToNormal: {
      default: false
    },
    value: {
      default: ''
    },
    height: {
      default: '100%'
    },
    mode: {
      default: '' // aiEditor
    },
    noNeedToken: {
      default: false
    },
  },
  data() {
    return {
      showViewer: false,
      srcList: [],
      curtIndex: 0
    };
  },
  computed: {
    showVal() {
      if (!this.value) return ''
      let val = String(this.value)
      
      val = val.replace(/{learun_img_api}/g, `${this.apiUrl}system/annexesfile/`).replace(/{learun_img_token}/g, `token=${this.noNeedToken ? 'img' : this.token}&isGetFileFromTenant=${this.isUploadToNormal ? this.saasMode : false}`)
      // String(val).replace(/<img.*?(?:>|\/>)/g, (item) => {
      //   const obj = this.getHtmlAttr(item)
      //   if (obj.src) {
      //     let src = obj.src
      //     if (!src.startsWith('http://') && !src.startsWith('https://')) src = location.origin + src
      //     this.srcList.push(decodeURIComponent(src))
      //   }
      //   return item
      // })
      if (this.mode == 'aiEditor') {
        //  style="text-align: center"
        val = val.replace(/<img(.*?)>/g, '<div class="clearfix"><img$1></div>')
      }
      val = val.replace(/<p><\/p>/g, '<br/>')
      return val
    }
  },
  watch: {
    showVal() {
      this.getSrcList()
    },
  },
  mounted() {
    this.getSrcList()
  },
  methods: {
    getSrcList() {
      this.$nextTick(() => {
        if (!this.$refs.rich) return
        let arr = this.$refs.rich.querySelectorAll('img')
        this.srcList = []
        if (arr && arr.length) {
          for (let i=0;i<arr.length;i++) {
            let src = arr[i].src
            // if (!src.startsWith('http://') && !src.startsWith('https://')) src = location.origin + src
            this.srcList.push(src)
          }
        }
      })
    },
    clickHandler(e) {
      let target = e.target
      if (target.tagName == 'IMG') {
        e.stopPropagation()
        let index = this.srcList.indexOf(target.src)
        // this.showImage(index)

        this.$preview(`/j-preview/preview.html?src=${encodeURIComponent(target.src)}&ext=png`, { type: 'img', index, urls: this.srcList })
      } else {
        this.$emit('click')
      }
    },
    closeViewer() {
      this.showViewer = false;
    },
    switchHand(e) {
      this.curtIndex = e + 1;
    },
    showImage(index) {
      this.curtIndex = index
      this.showViewer = true;
    },
  }
}
</script>
<style scoped lang="less">
@import "../../lrEditor/_src/index.less";

.rich-box {
  height: 100%;

  p {
    margin: 0 !important;
  }
}

:deep(.ql-editor) {
  p {
    margin: 0 !important;
  }
}

.ql-editor {
  padding: 12px !important;

  p {
    margin: 0 !important;
  }

  img {
    cursor: pointer !important;
  }
}

.aie-theme-light {
  padding: 0 !important;
}
</style>